import React from "react";
import { View, Text, StyleSheet } from "react-native";

/**
 * NotFound Component
 * A reusable component that displays a 404 error message along with an animated Lottie illustration.
 *
 * @param {Object} props - Component props
 * @param {JSX.Element} props.lottieElement - The Lottie animation element to be displayed.
 */
export const NotFound = ({ lottieElement }) => {
  return (
    <View style={styles.container}>
      {/* Render the provided Lottie animation element */}
      {lottieElement}
      
      {/* Display the 404 error message */}
      <Text style={styles.title}>404 - Page Not Found</Text>
      <Text style={styles.message}>
        Sorry, the page you are looking for does not exist.
      </Text>
    </View>
  );
};

// Styles for the NotFound component
const styles = StyleSheet.create({
  container: {
    flex: 1, // Makes the container take up the full height of the screen
    justifyContent: "center", // Centers content vertically
    alignItems: "center", // Centers content horizontally
    backgroundColor: "#f8f9fa", // Light gray background color
    padding: 20, // Adds padding around the container
    fontFamily:'GT-Walsheim'
  },
  title: {
    fontSize: 24, // Sets the font size for the title
    fontWeight: "bold", // Makes the title bold
    color: "#333", // Dark gray text color
    marginTop: 10, // Adds spacing above the title
    fontFamily:'GT-Walsheim'
  },
  message: {
    fontSize: 16, // Sets the font size for the message text
    color: "#666", // Medium gray text color
    textAlign: "center", // Centers the message text
    maxWidth: 300, // Limits the message width for better readability
    marginTop: 5, // Adds spacing above the message text
    fontFamily:'GT-Walsheim'
  },
});

export default NotFound;
